<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h2>{{ $store.state.analytics.subTitle }}</h2>
                <h2 style="color:#EED202;" class="ml-3">
                    {{ ' By ' + ByDrill }}
                </h2>
                <v-spacer></v-spacer>
                <v-btn v-if="dashboard" dark icon @click="$emit('close')"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
                <v-btn v-else dark icon to="/shift-analytics-detail"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :search="search"
                    height="600px"
                    disable-items-per-page
                    disable-pagination
                    class="elevation-1"
                    hide-default-footer
                    :fixed-header="true"
                    v-if="show == 1"
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="search"
                                    label="Search"
                                    class="mb-1"
                                    dense
                                    style="margin-top: 0px;padding: 10px;"
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-btn
                                    color="success"
                                    class="float-left"
                                    @click="exportExcel"
                                    icon
                                    ><v-icon>mdi-microsoft-excel</v-icon></v-btn
                                >
                            </v-col>
                        </v-row>
                        <table
                            style="width: 100%;"
                            class="tbla"
                            dense
                            v-if="view"
                        >
                            <thead>
                                <tr class="text-center">
                                    <td :width="ttWidth" class="text-right">
                                        Totals
                                    </td>
                                    <th
                                        :width="ttResult"
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        $
                                        {{
                                            new Intl.NumberFormat().format(
                                                Number(Revenue).toFixed(2)
                                            )
                                        }}
                                    </th>
                                    <th
                                        :width="ttResult"
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        $
                                        {{
                                            new Intl.NumberFormat().format(
                                                Number(OtherRev).toFixed(2)
                                            )
                                        }}
                                    </th>
                                    <th
                                        :width="ttResult"
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        $
                                        {{
                                            new Intl.NumberFormat().format(
                                                Number(Expenses).toFixed(2)
                                            )
                                        }}
                                    </th>
                                    <th
                                        :width="ttResult"
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        $
                                        {{
                                            new Intl.NumberFormat().format(
                                                Number(OtherExp).toFixed(2)
                                            )
                                        }}
                                    </th>
                                    <th
                                        :width="ttResult"
                                        scope="col"
                                        colspan="1"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    ></th>
                                    <th
                                        style="background-color: #336ca5; color: aliceblue;"
                                    ></th>
                                </tr>
                                <tr>
                                    <td width="9%" class="text-right">
                                        Grand Totals
                                    </td>

                                    <th
                                        scope="col"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    ></th>
                                    <th
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        ${{
                                            new Intl.NumberFormat().format(
                                                Number(
                                                    OtherRev + Revenue
                                                ).toFixed(2)
                                            )
                                        }}
                                    </th>

                                    <th
                                        style="background-color: #336ca5; color: aliceblue;"
                                    ></th>
                                    <th
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        ${{
                                            new Intl.NumberFormat().format(
                                                Number(
                                                    Expenses + OtherExp
                                                ).toFixed(2)
                                            )
                                        }}
                                    </th>
                                    <th
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        ${{
                                            new Intl.NumberFormat().format(
                                                Number(Net).toFixed(2)
                                            )
                                        }}
                                    </th>
                                    <th
                                        scope="col"
                                        class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;"
                                    >
                                        {{
                                            Number(
                                                (Net / (OtherRev + Revenue)) *
                                                    100
                                            ).toFixed(2)
                                        }}
                                        %
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </template>

                    <template v-slot:item.Revenue="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                                new Intl.NumberFormat().format(
                                    Number(item.Revenue).toFixed(2)
                                )
                            }}
                        </td>
                    </template>
                    <template v-slot:item.OtherRev="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                                new Intl.NumberFormat().format(
                                    Number(item.OtherRev).toFixed(2)
                                )
                            }}
                        </td>
                    </template>
                    <template v-slot:item.Expenses="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                                new Intl.NumberFormat().format(
                                    Number(item.Expenses).toFixed(2)
                                )
                            }}
                        </td>
                    </template>
                    <template v-slot:item.OtherExp="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                                new Intl.NumberFormat().format(
                                    Number(item.OtherExp).toFixed(2)
                                )
                            }}
                        </td>
                    </template>
                    <template v-slot:item.net="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                                new Intl.NumberFormat().format(
                                    Number(item.net).toFixed(2)
                                )
                            }}
                        </td>
                    </template>
                    <template v-slot:item.Margin="{ item }">
                        <td
                            style="border:1px #4f83cc solid;text-align: right;"
                            class="hover"
                            @click="open(item, 0)"
                        >
                            {{ item.Margin }}
                        </td>
                    </template>
                    <template v-slot:item.DriverMargin="{ item }">
                        <td class="text-right">
                            {{ Number(item.DriverMargin).toFixed(2) }} %
                        </td>
                    </template>
                    <template v-slot:item.TotalRevenue="{ item }">
                        <td class="text-right">
                            {{ Number(item.TotalRevenue).toFixed(2) }}
                        </td>
                    </template>
                    <template v-slot:item.ShiftDetail="{ item }" v-if="!view">
                        <td
                            style="border:1px #4f83cc solid;text-align: right;"
                            class="hover"
                            @click="open(item, 0)"
                        >
                            {{ item.ShiftDetail }}
                        </td>
                    </template>

                    <template v-slot:item.Payroll="{ item }" v-if="!view">
                        <td
                            style="border:1px #4f83cc solid;text-align: right;"
                            class="hover"
                            @click="open(item, 1)"
                        >
                            {{ item.Payroll }}
                        </td>
                    </template>
                </v-data-table>
                <v-container style="height: 400px;" v-else>
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Getting your files
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="primary accent-4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
                <!-------------------------------------TB Totals ----------------------------------------->
                <table
                    style="width: 100%;"
                    class="tbla"
                    dense
                    v-if="
                        $store.state.analytics.subTitle ==
                            'Shift Analysis By Company Costs'
                    "
                >
                    <thead>
                        <tr class="text-center">
                            <td :width="ttWidth" class="text-right">Totals</td>

                            <th
                                :width="ttResult"
                                scope="col"
                                class="text-center"
                                style="background-color: #336ca5; color: aliceblue;"
                            >
                                {{
                                    new Intl.NumberFormat().format(
                                        Number(totals['TotalRevenue']).toFixed(
                                            2
                                        )
                                    )
                                }}
                            </th>
                            <th
                                :width="ttResult"
                                scope="col"
                                class="text-center"
                                style="background-color: #336ca5; color: aliceblue;"
                            >
                                {{
                                    new Intl.NumberFormat().format(
                                        Number(totals['Payroll']).toFixed(2)
                                    )
                                }}
                            </th>
                            <th
                                :width="ttResult"
                                scope="col"
                                class="text-center"
                                style="background-color: #336ca5; color: aliceblue;"
                            >
                                {{
                                    Number(
                                        (totals['Payroll'] /
                                            totals['TotalRevenue']) *
                                            100
                                    ).toFixed(2)
                                }}%
                            </th>
                            <td :width="ttResult"></td>
                        </tr>
                    </thead>
                </table>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    directives: { mask },
    props: ['dashboard'],
    data: function() {
        return {
            items: [],
            headers: [],
            search: '',
            show: 0,
            colspan: 0,
            view: null,
            drillDown: '',
            ByDrill: '',
            Revenue: 0,
            OtherRev: 0,
            Expenses: 0,
            OtherExp: 0,
            ttWidth: '40%',
            ttResult: '10%',
            Net: 0
        };
    },
    mounted() {
        console.log(this.dashboard);
        console.log(this.$store.state.analytics.itm);
        switch (this.$store.state.analytics.title) {
            case 'View By Truck':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.Name;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Trailer':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.Name;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Trailer':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.Name;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Driver':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.DriverName;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Customer':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.Name;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Truck-Yard':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.Yard;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Station':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.StationName;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Terminal':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    {
                        align: 'right',
                        text: 'Revenue',
                        value: 'Revenue',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherRev',
                        value: 'OtherRev',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Expenses',
                        value: 'Expenses',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'OtherExp',
                        value: 'OtherExp',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Net',
                        value: 'net',
                        width: this.ttResult
                    },
                    {
                        align: 'right',
                        text: 'Margin',
                        value: 'Margin',
                        width: this.ttResult
                    }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.TerminalName;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View Regions Totals':
                this.headers = [
                    {
                        align: 'left',
                        text: 'ShiftDetail',
                        value: 'ShiftDetail',
                        width: '8%'
                    },
                    {
                        align: 'right',
                        text: 'SD Date',
                        value: 'DateShift',
                        width: '20%'
                    },
                    { align: 'right', text: 'Revenue', value: 'Revenue' },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev' },
                    { align: 'right', text: 'Expenses', value: 'Expenses' },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp' },
                    { align: 'right', text: 'Net', value: 'net' },
                    { align: 'right', text: 'Margin', value: 'Margin' }
                ];
                this.view = true;
                this.ByDrill = this.$store.state.analytics.itm.PrincipalRegion;
                this.drillDown = '/shift-analytics/transacting';
                break;
            case 'View By Company Truck Actual Profit':
                if (
                    this.$store.state.analytics.specific ==
                    'shift-analytics/actual-cost/truck'
                ) {
                    this.headers = [
                        {
                            align: 'left',
                            text: 'ShiftDetail',
                            value: 'ShiftDetail',
                            width: '10%'
                        },
                        {
                            align: 'right',
                            text: 'Date',
                            value: 'Date',
                            width: '10%'
                        },
                        {
                            align: 'right',
                            text: 'Driver',
                            value: 'Name',
                            width: '30%'
                        },
                        {
                            align: 'right',
                            text: 'Tot. Revenue',
                            value: 'TotalRevenue',
                            width: '10%'
                        },
                        {
                            align: 'right',
                            text: 'Driver Pay',
                            value: 'Payroll',
                            width: '10%'
                        },
                        {
                            align: 'right',
                            text: 'Driver Margin',
                            value: 'DriverMargin',
                            width: '10%'
                        },
                        {
                            align: 'right',
                            text: 'Yard',
                            value: 'Yard',
                            width: '10%'
                        }
                    ];
                    this.ttWidth = '50%';
                } else {
                    this.headers = [
                        {
                            align: 'left',
                            text: 'ShiftDetail',
                            value: 'ShiftDetail',
                            width: '8%'
                        },
                        {
                            align: 'right',
                            text: 'Main Unit',
                            value: 'TruckName'
                        },
                        { align: 'right', text: 'Date', value: 'Date' },
                        { align: 'right', text: 'Driver', value: 'Name' },
                        {
                            align: 'right',
                            text: 'Tot. Revenue',
                            value: 'TotalRevenue'
                        },
                        { align: 'right', text: 'Payroll', value: 'Payroll' },
                        {
                            align: 'right',
                            text: 'Driver Margin',
                            value: 'DriverMargin'
                        },
                        { align: 'right', text: 'Yard', value: 'Yard' }
                    ];
                }
                this.ByDrill = this.$store.state.analytics.itm.TruckNameProf;
                this.drillDown = '/shift-analytics/transacting';
                this.view = false;
                break;
        }
        this.getItems();
    },
    methods: {
        getItems: function() {
            this.Revenue = 0;
            this.OtherRev = 0;
            this.Expenses = 0;
            this.OtherExp = 0;
            this.Net = 0;
            var parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                Truck: this.$store.state.analytics.itm.TruckID,
                Trailer: this.$store.state.analytics.itm.TrailerId,
                Driver: this.$store.state.analytics.itm.DriverID,
                Yard: this.$store.state.analytics.itm.YardId,
                Station: this.$store.state.analytics.itm.Station,
                Customer: this.$store.state.analytics.itm.CustGrpid,
                Terminal: this.$store.state.analytics.itm.TerminalID,
                ReplacementUnit: this.$store.state.analytics.itm
                    .ReplacementUnit,
                Region: this.$store.state.analytics.itm.PrincipalRegionID,
                TruckName: this.$store.state.analytics.itm.TruckNameProf
            };
            console.log(parms);
            axios
                .post(this.$store.state.analytics.specific, parms)
                .then(response => {
                    if (!this.view) {
                        this.items = response.data['data'];
                        this.totals = response.data['totals'][0];
                        console.log(this.totals);
                    } else {
                        this.items = response.data;
                    }
                    this.items.forEach(element => {
                        this.Revenue = element.Revenue + this.Revenue;
                        this.OtherRev = element.OtherRev + this.OtherRev;
                        this.Expenses = element.Expenses + this.Expenses;
                        this.OtherExp = element.OtherExp + this.OtherExp;
                        this.Net = element.net + this.Net;
                    });
                    this.show = 1;
                })
                .catch(function(error) {
                    console.log(error);
                    this.show = 1;
                });
        },
        exportExcel: function() {
            var parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                Truck: this.$store.state.analytics.itm.TruckID,
                Trailer: this.$store.state.analytics.itm.TrailerId,
                Driver: this.$store.state.analytics.itm.DriverID,
                Yard: this.$store.state.analytics.itm.YardId,
                Station: this.$store.state.analytics.itm.Station,
                Customer: this.$store.state.analytics.itm.CustGrpid,
                Terminal: this.$store.state.analytics.itm.TerminalID,
                ReplacementUnit: this.$store.state.analytics.itm
                    .ReplacementUnit,
                Region: this.$store.state.analytics.itm.PrincipalRegionID,
                TruckName: this.$store.state.analytics.itm.TruckNameProf,
                Export: 1
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post(this.$store.state.analytics.specific, parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        this.$store.state.analytics.subTitle +
                            ' By ' +
                            this.ByDrill +
                            '.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        open: function(itm, drill) {
            if (this.dashboard) {
                this.$store.state.analytics.subItem = itm;
                this.$emit('drilldown');
            } else {
                if (drill == 1) {
                    this.drillDown = '/shift-analytics/posting';
                }
                this.$store.state.analytics.subItem = itm;
                console.log(itm);
                this.$store.state.analytics.return =
                    '/shift-analytics/specific';
                this.$router.push(this.drillDown);
            }
        }
    }
};
</script>
<style>
.hover:hover {
    background: #a4a9de;
}
</style>
